import {Link, useParams} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi, setTitle, consoleLog} from '../../utils/functions';
import {UserContext, TestService} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
//import Genres from './components/genres/genres';
//import AudioBox from './components/audio/audiobox';
//import moment from 'moment';
//import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
//import '../components/fontawesome/fontawesome';
import CopyBox from '../components/bbcode/copybox';

//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
//import InputGroup from 'react-bootstrap/InputGroup';

//import './css/index.css';
//import './css/header.css';

class PortalAdminEmbeds extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			service: {
				status: false,
				id: this.props.service,
				name: '',
			},
			names: [],
			embeds: [],
			profile: {
				embed_color: "#000000",
				embed_darkmode: "false"
			},
			colors: ['#ffffff', '#000000', '#f52100', '#5a0dbe', '#ffdc01', '#49f51f', '#d2f839', '#01f687', '#c60b27', '#0d17db', '#F6C107', '#ff0f59', '#ff36e8', '#08c892', '#ffc943', '#0bf1ee', '#a52077', '#3fb9ed', '#00afff', '#d61935', '#F40919', '#6a0bdf', '#ff5434', '#ffc600', '#ed393a', '#f66254', '#a9f100', '#5400ff', '#04538b', '#318fcd'],
		};
		this.darkMode = this.darkMode.bind(this);
		this.color = this.color.bind(this);
		this.changeMode = this.changeMode.bind(this);
  };

  async componentDidMount() {
		//document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( getUser );
		const y = await value.setWorker( this.props.service );
		//let server = value.worker[this.props.service] || y[this.props.service];
		EventEmitter.emit('/client', y);

		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		const x = await postApi(`${this.context.worker[this.props.service]}/v3/admin/embeds`, params);
		consoleLog(x.data);

		this.setState({names: x.data.names, embeds: x.data.embeds});

		if( this.state.service.status === false ) {
			let service = this.state.service;
			service.status = true;
			service.name = x.data.servicename;
			let profile = this.state.profile;
			profile = x.data.profile;
			this.setState({service, profile});
			setTitle('Embeds', x.data.servicename);
		};

		//let params = new URLSearchParams();
		//const x = await postApi(`${server}/v3/admin/organiser`, params);
		//this.setState({status: true, services: x.data.Services});
		

		/*
		let params = new URLSearchParams();
		const x = await postApi('/v3/index', params);
		
		//this.setState({clubbers: x.data.Clubbers, radio: x.data.Radio, next: x.data.Next, posters: x.data.WeeklyDJs, sets: x.data.Sets, status: true, affliiate: x.data.Affiliate});

		const IndexSchedule = EventEmitter.addListener('/index/schedule', async data => {
			this.setState({next: data.Next, live: data.Live});
		}); this.setState({IndexSchedule});
		*/

	}

	componentWillUnmount() {
	}


	async darkMode() {
		let profile = this.state.profile;
		profile.embed_darkmode = profile.embed_darkmode==='false'?'true':'false';
		this.setState({profile}, ()=>{
			this.changeMode();
		});
	}

	async color(color) {
		if( this.state.profile.embed_color === color ) return;
		let profile = this.state.profile;
		profile.embed_color = color;
		this.setState({profile}, ()=>{
			this.changeMode();
		});
	}

	async changeMode() {
		let profile = this.state.profile;
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		params.append('darkmode', profile.embed_darkmode);
		params.append('color', profile.embed_color);
		await putApi(`${this.context.worker[this.props.service]}/v3/admin/embeds`, params);
	}
	

	render() {
		const user = this.context;

		const names = this.state.names.map((e,i) => {
			return (
				<Link key={i} to={`#${e}`}><Button  size="sm">{e}</Button></Link>
			)
		});

		const colors = this.state.colors.map((e,i) => {
			return (
				<div key={i} style={{width: this.state.profile.embed_color===e?26:30, height: this.state.profile.embed_color===e?26:30, marginTop: this.state.profile.embed_color===e?2:0, backgroundColor: e, marginRight: 10, borderRadius: '50%', border: '1px solid #888888', cursor: 'pointer', boxShadow: this.state.profile.embed_color===e?'0px 0px 4px 4px rgba(0,0,0,0.9)':'0 0'}} onClick={()=>this.color(e)}>
					{/*this.state.profile.embed_color === e &&
						<FontAwesomeIcon icon="check" size="xl" style={{color: '#00FF00', position: 'absolute', margin: 'auto'}} />
					*/}
				</div>
			)
		});

		const embeds = this.state.embeds.map((e,i) => {
			//if( e.type !== 'Mixcloud Replays' )
			return (
				<Col xs={12} key={i}>
					<div className="card custom-card">
						<div className="card-header p-0">
							<div className="d-flex p-3 ">
								
								<div className="mt-0 text-start">
									<span className="fs-14 fw-semibold">{this.state.service.name} - {e.type}</span>
								</div>
							</div>
						</div>
						<div className="card-body">
							<CopyBox content={`<iframe src="https:\/\/embed.ultrastream.io/${e.code}" id="${e.code}" width="100%"></iframe>`}/>
							<iframe src={`https://embed.ultrastream.io/${e.code}`} id={e.code} title="embed" width="100%" />
						</div>
						
					</div>
				</Col>
			)
		});

		return (
			<>
				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Website Embeds</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								<li className="breadcrumb-item"><Link to={`/${this.state.service.id}`}>{this.state.service.name}</Link></li>
								<li className="breadcrumb-item active" aria-current="page">Dashboard</li>
							</ol>
						</nav>
					</div>
				</div>

				{this.state.service.status === true &&
					<div className="main-content app-content">
						<div className="container-fluid">
							<Row>
									
								<Col lg={12}>
                  <div className="card custom-card">
										<div className="card-header p-0">
											<div className="d-flex p-3 ">
												<div className="">
													<svg className="me-4  bg-success-transparent  alt-notify" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#75cfa5" d="m20.34 9.32-13.99-7a3 3 0 0 0-4.08 3.9L4.41 11l.26.59a1.06 1.06 0 0 1 0 .82l-.26.59-2.14 4.78a2.954 2.954 0 0 0 .67 3.38A2.966 2.966 0 0 0 5 22a3.141 3.141 0 0 0 1.35-.32l13.99-7a2.993 2.993 0 0 0 0-5.36Z"></path><path fill="#198754" d="M14.46 12a.997.997 0 0 1-1 1H4.41l.26-.59a1.06 1.06 0 0 0 0-.82L4.41 11h9.05a.997.997 0 0 1 1 1Z"></path></svg>
												</div>
												<div className="mt-0 text-start">
													<span className="fs-14 fw-semibold">Website Embeds</span>
													<p className="fs-13 text-muted mb-0">Enhance your content into your website</p>
												</div>
                      </div>
                    </div>
										<TestService service={this.state.service.id} worker={user.worker[this.state.service.id]} />
										<div className="card-body">
											{names}
										</div>
										
                  </div>
                </Col>

								<Col xs={12}>
									<div className="card custom-card">
										<div className="card-header">
											<div className="card-title">
												Embed Help
											</div>
										</div>
										<div className="card-body">
											To help maintain heights of the website embeds, please include this javascript file into your website:
											<br /><br />
											<CopyBox content={`<script src="https:\/\/embed.ultrastream.io\/embed.js"></script> `}/>
											<br />
											
											<div className="d-flex">
												<div className={`toggle toggle-success ${this.state.profile.embed_darkmode==='true'?'on':''}`} onClick={()=>this.darkMode()}> 
													<span></span>
												</div>
												<label className="ms-3 pt-1">Dark Mode</label>
											</div>
											<br />
											Colour Selection:<br />
											<div className="d-flex">
												{colors}
											</div>
											
										</div>
									</div>
								</Col>

								{embeds}
									
							</Row>
						</div>
					</div>
				}
			</>
		);
	}
}

const Embeds = props => {
  const { service } = useParams();
  return <PortalAdminEmbeds service={service} {...props} />
}
export default Embeds;